module.exports = __webpack_public_path__ + "static/media/ninesaver-favicon.8d2b9202.ico";